
import { useEffect, useState } from 'react';
import { Singleton } from '../../../../../core/services/Singleton';
import { BasicTable, MASK_DATE } from '../../../../theme/Component/BasicTable';
import { toast } from 'react-toastify';
import { StateReimbursementEditor } from './StateReimbursementEditor';
import { BasicPage } from '../../../../theme/Component/BasicPage';
import { BasicButton } from '../../../../theme/Component/BasicButton';
import { ListMenu } from '../../../../theme/Component/ListMenu';
import { Modal } from '../../../../theme/Component/Modal';
import { CashReimbursementBudget } from './CashReimbursementBudget';
import useDataBean from '../../../../../core/services/dataBean/useDataBean';
import { _CashReimbursement, _CashReimbursementBudget, _DocumentFactory, _single } from '../../../../../core/services/dataBean/EntityCatalog';
import { ModalConfirm } from '../../../../theme/Component/ModalConfirm';
import { CashReimbursementItem } from './CashReimbursementItem';
import { EstablishBaseCashReimbursement } from './EstablishBaseCashReimbursement';
import { CashDeskAccountSelector } from '../../CashDeskAccount/CashDeskAccountSelector';
import { RPsEditor } from '../../../../contabilidad/budgetObligationFactory/RPsEditor';
import { SelectorDocumentFactory } from '../../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory';
import { DocumentStorageEditor } from '../../../../contabilidad/bodegaDocumentos/DocumentStorageEditor';
import { BudgetListForRefund } from './BudgetListForRefund/BudgetListForRefund';
import { DocumentViewer } from '../../../../theme/Component/DocumentViewer';
import { _CashReimbursementCreate, _CashReimbursementnullify, _CreateMoney, _DocumentsByCash } from '../../../../../core/services/dataBean/EntityCatalogVdos';
import { InputDate } from '../../../../theme/Input/InputDate';
import { BankAccountSelect } from '../../BankAccount/BankAccountSelect';
import { CDPCatalog } from '../../CashDeskAccount/CashDeskAccountCDP/CDPCatalog/CDPCatalog';
import { CashDeskAccountCDP } from '../../CashDeskAccount/CashDeskAccountCDP/CashDeskAccountCDP';
import { PrintJson } from '../../../../theme/Component/PrintJson';

interface Props {
    idCashDeskA?: number;
    menuComponent?: boolean;
}

export const CashReimbursementHistory = ({ idCashDeskA, menuComponent }: Props) => {

    const { bean, setBean, lista, setLista, instance, handleChange } = useDataBean(_CashReimbursement);
    const single = Singleton.getInstance()
    const [state, setState] = useState<number>(0)
    const [formatodoc, setFormatodoc] = useState<any>([]);
    const nullify = useDataBean(_CashReimbursementnullify);
    const createcaja = useDataBean(_CashReimbursementCreate);
    const docsbycash = useDataBean(_DocumentsByCash);
    const _documentos = useDataBean(_DocumentFactory);
    const _createMoney = useDataBean(_CreateMoney);
    const [docs, setDocs] = useState<any>([]);
    const [mensajeCaja, setMensajeCaja] = useState<string | null>(null);
    const [docsvdos, setDocsvdos] = useState<any>([]);
    const [listString, setListString] = useState<any>([]);
    const [docsvtres, setDocsvtres] = useState<any>([]);
    const [docscuatro, setDocscuatro] = useState<any>([]);
    const [year, setYear] = useState<number>(single.getCurrenYear())
    const [cashDesk, setCashDesk] = useState<number>(null);
    const [cajamenor, setCajamenor] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [download, setDownload] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modaldocgenerate, setModalDocgenerate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [viewstring, setViewstring] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [anular, setAnular] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [certificate, setModalcertificate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalvercash, setModalvercash] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [moneybase, setmoneybase] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [registro, setregistro] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [obligation, setobligation] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [egreso, setegreso] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [consultar, setconsultar] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [resgistropresupuestal, setregistropresupuestal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalC, setModalC] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-sm", });
    const [modalConcep, setModalConcep] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-lg", });
    const [modalSeeUBL, setModalSeeUBL] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalMoneyBase, setModalMoneyBase] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-xl", });
    const [modalAssingRP, setModalAssingRP] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: "modal-md", });
    useEffect(() => {
        if (registro.view) {
            verDocumentos();
        }
    }, [registro.view]);

    useEffect(() => {
        if (obligation.view) {
            verDocumentosvdos();
        }
    }, [obligation.view]);

    useEffect(() => {
        if (egreso.view) {
            verDocumentosvtres();
        }
    }, [egreso.view]);

    useEffect(() => {
        if (egreso.view) {
            verDocumentosvtres();
        }
    }, [egreso.view]);
    const validateGetLista = () => {
        if (!year) {
            toast.error("año no valido");
        } else if (isNaN(state)) {
            toast.error("Estado no valido");
        } else if (idCashDeskA ? !idCashDeskA : !cashDesk) {
            toast.error("Caja no valida");
        } else {
            getLista()
        }
    }

    useEffect(() => {
        if (!menuComponent) {
            getLista()
        }
    }, [])

    const getLista = () => {
        instance.getCashReimbursementCatalog(year, idCashDeskA ?? cashDesk, state).then(
            (resp) => {
                if (resp) {
                    // Primero enriqueces los datos
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.Obligation =
                            (user.DataBeanProperties.OBMnemonic ?? "") +
                            "-" +
                            (user.DataBeanProperties.OBConsecutive ?? "") +
                            "-" + (user.DataBeanProperties.OBDate ?? "");
                        user.DataBeanProperties.Egreso =
                            (user.DataBeanProperties.DocMnemonic ?? "") +
                            "-" +
                            (user.DataBeanProperties.DocConsecutive ?? "") +
                            "-" + (user.DataBeanProperties.DocDate ?? "")
                    });

                    // Luego filtras y seteas
                    const filteredList = x.filter(item =>
                        item.DataBeanProperties.IDCashDeskAccount === (idCashDeskA ?? cashDesk)
                    );
                    setLista(filteredList);
                }
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }
    const vervalorespendientes = () => {
        setconsultar({ ...consultar, view: true });
    }
    const createmoneybase = () => {
        setmoneybase({ ...moneybase, view: true });
    }
    const crearcajamenor = () => {
        setCajamenor({ ...cajamenor, view: true });
    }
    const vercertificate = () => {
        setModalcertificate({ ...certificate, view: true });
    }
    const createMoneyBaseForCashDeskAccount = () => {
        _createMoney.instance.createMoneyBaseForCashDeskAccount(_createMoney.bean.IDCashDeskAccount, _createMoney.bean.IDCashDeskAccountCDP, _createMoney.bean.Observations, _createMoney.bean.AccountantDate, _single.getAccountID()).then(
            (resp) => {
                const msg = resp.MsgList?.[0] ?? null;
                setMensajeCaja(msg); // Guardar mensaje
                setDocscuatro(resp.DocumentURL)
                toast.success('Creado')
                setModalvercash({ ...modalvercash, view: true });
                setmoneybase({ ...moneybase, view: false });
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }
    const nullifyCashReimbursement = () => {
        nullify.instance.nullifyCashReimbursement(bean.IDCashReimbursement, bean.CashReimbursementDate, nullify.bean.Description, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                setAnular({ ...anular, view: false });
                toast.success('Anulado')
                setViewstring({ ...viewstring, view: true });
                setListString(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }
    const createCashReimbursementAdjustment = () => {
        createcaja.instance.createCashReimbursementAdjustment(createcaja.bean.IDCashDeskAccount, createcaja.bean.IDDocument, createcaja.bean.DocumentDate, _single.getAccountID()).then(
            (resp) => {
                console.log(resp)
                setCajamenor({ ...cajamenor, view: false });
                toast.success('Creado')
                // setViewstring({ ...viewstring, view: true });
                // setListString(resp)
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }
    const getDocumentsByCashReimbursement = () => {
        docsbycash.instance.getDocumentsByCashReimbursement(bean.IDCashReimbursement, bean.CashReimbursementDate).then(
            (resp) => {
                console.log(resp)
                toast.success('Generado')
                setFormatodoc(resp[0]);
                setModalDocgenerate({ ...modaldocgenerate, "view": true })
            }
        ).catch(
            err => {
                console.error(err)
            }
        )
    }
    const create = () => {
        setBean({
            IDCashDeskAccount: idCashDeskA,
            IDEmployee: single.getAccountID(),
            Year: single.getCurrenYear(),
        })
        setModal({ ...modal, view: true, "name": `Crear Rembolso` });
    }
    const verDocumentos = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.RPIDDocument, null, bean.RPDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                    setregistro({ ...registro, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const verDocumentosvdos = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.OBIDDocument, null, bean.OBDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsvdos(resp.DocumentURL);
                    setobligation({ ...obligation, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const verDocumentosvtres = () => {

        if (bean) {
            _documentos.instance.getPdfAccountantDocument(bean.DocIDDocument, null, bean.DocDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocsvtres(resp.DocumentURL);
                    setegreso({ ...egreso, "view": true });
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }
    const createCashReimbursement = () => {
        instance.updateCashReimbursement(bean).then(
            (resp: any) => {
                setModal({ ...modal, "view": false })
                getLista();
                setBean({});
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
        setModal({ ...modal, "view": false });
    }

    const deleteReimbursement = () => {
        instance.deleteCashReimbursement(bean.IDCashReimbursement, single.getCurrenDate()).then(
            (resp) => {
                getLista();
                setModalC({ ...modalC, "view": false })
            }
        ).catch(
            err => {
                toast.error(err)
            }
        )
    }
    const head = [
        { title: 'ID', property: "IDCashReimbursement" },
        { title: 'Caja Dependiente', property: 'IDCashDeskAccount' },
        { title: 'Vigencia Reembolso', property: 'DocumentsYear' },
        { title: 'Estado del Proceso', property: 'StateName' },
        { title: 'Tipo de Reembolso', property: 'TypeName' },
        { title: 'No Externo de Referencia', property: 'SecuenceName' },
        { title: 'Registro Presupuestal', property: 'RPDocumentName' },
        // { title: 'Valor RP', property: 'RPValue' },
        { title: 'Valor Pagado Reembolso', property: 'PaidedValue' },
        { title: 'Valor Reembolso Presupuestal', property: 'OBValue' },
        { title: 'Valor Reembolso NO Presupuestal', property: 'NonBudgetValue' },
        { title: 'Obligación', property: 'Obligation' },
        { title: 'Documento Causación/Comprobante de Egreso', property: 'Egreso' },
        // { title: '% Uso', property: 'Percent' },
        // { title: 'No CDP', property: 'CDPMnemonic' },
        // { title: 'Fecha de CDP', property: 'CDPDate' },
        // { title: 'Documento Contable', property: 'DocMnemonic' },
        // { title: 'Fecha de Documento Contable', property: 'DocDate' },
        // { title: 'Valor Autorizado', property: 'CDPValue' },
        // { title: 'Valor Utilizado', property: 'TotalValue' },
        // { title: '% de Uso', property: 'UsePercent' },
        { title: 'Creado por', property: 'EmployeeName' },
        { title: 'Fecha de Creación', property: 'Since', mask: MASK_DATE },
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: "Ver conceptos de Caja", icono: "ri-file-list-line", visible: true, evento: () => { setModalConcep({ ...modalConcep, "view": true, "name": "Conceptos de Caja" }) }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const listaBotonesMenuComp = () => {
        const botones = [
            { titulo: "Ver Registro Presupuestal", icono: "ri-file-list-line", visible: true, evento: () => { setregistro({ ...registro, "view": true }) }, },
            { titulo: "Ver Obligación", icono: "ri-file-list-line", visible: true, evento: () => { setobligation({ ...obligation, "view": true }) }, },
            { titulo: "Documento Causación / Comprobante de Egreso", icono: "ri-file-list-line", visible: true, evento: () => { setegreso({ ...egreso, "view": true }) }, },
            { titulo: "Anular Reembolso", icono: "ri-file-list-line", visible: true, evento: () => { setAnular({ ...anular, "view": true }) }, },
            { titulo: "Descargar Documentos Reembolsados", icono: "ri-file-download-line", visible: true, evento: () => { getDocumentsByCashReimbursement() }, },
            // { titulo: "Ver Facturas del Rembolso", icono: "ri-file-list-line", visible: true, evento: () => { setModalSeeUBL({ ...modalSeeUBL, "view": true, "name": "Facturas del Rembolso Seleccionado" }) }, },
            // { titulo: "Agregar Registro Presupuestal a Reembolso de Caja Menor", icono: "ri-file-list-line", visible: true, evento: () => { setregistropresupuestal({ ...resgistropresupuestal, "view": true, "name": "Agregar Registro Presupuestal a Reembolso de Caja Menor" }) }, },
            // { titulo: "Constituir Base de la Caja Menor", icono: "ri-money-dollar-box-line", visible: true, evento: () => { setModalMoneyBase({ ...modalMoneyBase, "view": true, "name": "Constituir Base de la Caja Menor" }) }, },
        ];
        return <ListMenu listaBotones={botones} />;
    };

    const iconButtonsItem = [
        { nombre: "Crear reembolsos de Caja Menor", visible: single.canCreate(), icono: "ri-file-add-line", evento: create },
    ];

    const updateCahs = () => {
        instance.updateCashReimbursement(bean).then(
            (resp) => {
                setModalAssingRP({ ...modalAssingRP, "view": false })
                getLista();
                setBean({});
            }
        ).catch(
            err => {
                console.log(err)
            }
        );
    }


    return (
        <>
            {menuComponent ?
                <BasicPage titulo='Gestionar Reembolsos de Caja Menor '>
                    <div className="row mb-3">
                        <div className="col-2">
                            <label className=''>Año:</label>
                            <input type='number' className='form-control' value={year} onChange={(e) => setYear(parseInt(e.target.value))} />
                        </div>
                        <div className="col-5">
                            <CashDeskAccountSelector id={cashDesk} onchange={(e) => { setCashDesk(e) }} />
                        </div>
                        <div className="col-3">
                            <StateReimbursementEditor idSelector={state} onChange={(e) => setState(parseInt(e))} />
                        </div>
                        <div className="col-2 d-flex align-items-end">
                            <BasicButton icon='ri-search-line' eventClick={() => { validateGetLista() }} >Buscar</BasicButton>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 mt-4">
                            <BasicButton icon='ri-search-line' eventClick={() => { vervalorespendientes() }} >Consultar Valores Pendientes de Reembolso </BasicButton>
                        </div>
                        <div className="col-md-5 mt-4">
                            <BasicButton icon='ri-device-line' eventClick={() => { vercertificate() }} >Certificados de Disponibilidad Presupuestal de Cajas Menores </BasicButton>
                        </div>
                        <div className="col-md-3 mt-4">
                            <BasicButton icon='ri-stack-line' eventClick={() => { createmoneybase() }} >Constituir Caja Menor </BasicButton>
                        </div>
                        <div className="col-md-4 mt-4">
                            <BasicButton icon='ri-chat-new-line' eventClick={() => { crearcajamenor() }} >Crear Ajuste a Caja Menor </BasicButton>
                        </div>

                    </div>


                    <div className="row">
                        <div className="col-md-12">
                            <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotonesMenuComp()} />
                        </div>
                        <div className="col-md-12">
                            <Modal modal={moneybase} updateModal={setmoneybase} eventModal={createMoneyBaseForCashDeskAccount}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <CashDeskAccountSelector id={_createMoney.bean.IDCashDeskAccount} onchange={(e) => { _createMoney.setBean({ ..._createMoney.bean, "IDCashDeskAccount": e }) }} />
                                    </div>
                                    {_createMoney.bean.IDCashDeskAccount && <>
                                        <div className="col-md-6">
                                            <CDPCatalog year={_single.getCurrenYear()} idCashDeskAccount={_createMoney.bean.IDCashDeskAccount} idSelector={_createMoney.bean.IDCashDeskAccountCDP} onChange={(e) => { _createMoney.setBean({ ..._createMoney.bean, "IDCashDeskAccountCDP": e }) }} />
                                        </div>
                                    </>}
                                    <div className="col-md-6">
                                        <InputDate notDate label="Fecha" name="AccountantDate" value={_createMoney.bean.AccountantDate} setDate={(e) => { _createMoney.setBean({ ..._createMoney.bean, "AccountantDate": e }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <label>Observaciones</label>
                                        <textarea className="form-control" name='Observations' value={_createMoney.bean.Observations} onChange={_createMoney.handleChange} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={cajamenor} updateModal={setCajamenor} eventModal={createCashReimbursementAdjustment}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <CashDeskAccountSelector id={createcaja.bean.IDCashDeskAccount} onchange={(e) => { createcaja.setBean({ ...createcaja.bean, "IDCashDeskAccount": e }) }} />
                                    </div>
                                    <div className="col-md-12">
                                        <DocumentStorageEditor mNemonic='ACM' label='Documento' onChange={(e) => { createcaja.setBean({ ...createcaja.bean, "IDDocument": e.IDDocument, "DocumentDate": e.DocumentDate }) }} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modaldocgenerate} updateModal={setModalDocgenerate}>
                                <>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {formatodoc?.DataBeanProperties?.URLLink && (
                                                // <PrintJson json={formato.DataBeanProperties.URLLink} />
                                                <div className="row">
                                                    <div className="col-md-12 mt-3">
                                                        <label>Descarga en el Siguiente Link:*</label>
                                                    </div>
                                                    <div className="col-md-6 mt-3">
                                                        <a href={formatodoc.DataBeanProperties.URLLink} target="_blank" rel="noopener noreferrer">
                                                            <strong>{formatodoc.DataBeanProperties.Filename}</strong>
                                                        </a>
                                                    </div>
                                                </div>

                                            )}
                                        </div>
                                    </div>

                                </>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={anular} updateModal={setAnular} eventModal={nullifyCashReimbursement}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <label>Descripción</label>
                                        <textarea className="form-control" name='Description' value={nullify.bean.Description} onChange={nullify.handleChange} />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={viewstring} updateModal={setViewstring}>
                                <div className="row">
                                    <PrintJson json={listString} />
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={certificate} updateModal={setModalcertificate}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <CashDeskAccountCDP />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={registro} updateModal={setregistro}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DocumentViewer
                                            list={docs}
                                            IDDocument={bean.RPIDDocument}
                                            Since={bean.RPDate}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={obligation} updateModal={setobligation}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DocumentViewer
                                            list={docsvdos}
                                            IDDocument={bean.OBIDDocument}
                                            Since={bean.OBDate}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={modalvercash} updateModal={setModalvercash}>
                                <div className="row">
                                    {mensajeCaja && (
                                        <div className="col-md-12">
                                            <div className="alert alert-warning" role="alert">
                                                {mensajeCaja}
                                            </div>
                                        </div>
                                    )}
                                    <div className="col-md-12">
                                        <DocumentViewer
                                            list={docscuatro}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={egreso} updateModal={setegreso}>
                                <div className="row">
                                    <div className="col-md-12">
                                        <DocumentViewer
                                            list={docsvtres}
                                            IDDocument={bean.DocIDDocument}
                                            Since={bean.DocDate}
                                        />
                                    </div>
                                </div>
                            </Modal>
                        </div>
                        <div className="col-md-12">
                            <Modal modal={consultar} updateModal={setconsultar}>
                                <>
                                    <BudgetListForRefund />
                                </>
                            </Modal>
                        </div>
                    </div>

                </BasicPage>
                :
                <>
                    <div className="row mb-2">
                        <div className="col-5">
                            <StateReimbursementEditor idSelector={state} onChange={(e) => setState(e)} />
                        </div>
                        <div className="col-5">
                            <label className=''>Año:</label>
                            <input type='number' className='form-control' value={year} onChange={(e) => setYear(parseInt(e.target.value))} />
                        </div>
                        <div className="col-2 d-flex align-items-end">
                            <BasicButton icon='ri-search-line' eventClick={() => { validateGetLista() }} >Buscar</BasicButton>
                        </div>
                    </div>
                    <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} body={lista} head={head} rowSet={setBean} />
                </>
            }

            {modalC.view &&
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteReimbursement} >
                    Eliminar Item
                </ModalConfirm>
            }

            {modalSeeUBL.view &&
                <Modal modal={modalSeeUBL} updateModal={setModalSeeUBL}>
                    <CashReimbursementItem _bean={bean} _cashReimbursementDate={bean.Since} _idCashReimbursement={bean.IDCashReimbursement} />
                </Modal>
            }

            {resgistropresupuestal.view &&
                <Modal modal={resgistropresupuestal} updateModal={setregistropresupuestal} eventModal={createCashReimbursement}>
                    <>
                        <RPsEditor label="Registro Presupuestal" _idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "RPDate": e.Since }) }} />
                    </>
                </Modal>
            }

            {modalConcep.view &&
                <Modal modal={modalConcep} updateModal={setModalConcep}>
                    <CashReimbursementBudget idCashReimbursement={bean.IDCashReimbursement} cashReimbursementDate={bean.Since} />
                </Modal>
            }

            {modalMoneyBase.view &&
                <Modal modal={modalMoneyBase} updateModal={setModalMoneyBase} eventModal={() => { }}>
                    <EstablishBaseCashReimbursement idCashReimbursement={bean.IDCashReimbursement} reimbursementDate={bean.Since} />
                </Modal>
            }

            {modal.view &&
                <Modal modal={modal} updateModal={setModal} eventModal={createCashReimbursement} >
                    <div className="row">
                        <div className="col-12">
                            <label>Año</label>
                            <input type="number" className='form-control' name='Year' value={bean.Year} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label >Número de Referencia Externo:</label>
                            <input type="text" className="form-control" name='SecuenceName' value={bean.SecuenceName} onChange={handleChange} />
                        </div>
                        <div className="col-12">
                            <label >Número de Expediente/Radicado:</label>
                            <input type="text" className="form-control" name='IDFiledNumber' value={bean.IDFiledNumber} onChange={handleChange} />
                        </div>
                    </div>
                </Modal>
            }

            <Modal modal={modalAssingRP} updateModal={setModalAssingRP} eventModal={updateCahs}>
                <div className="row">
                    <div className="col-md-12">
                        <DocumentStorageEditor label='Registro Presupuestal a Para Asignar' mNemonic='RP' onChange={(e) => { setBean({ ...bean, "RPIDDocument": e.IDDocument, "RPMnemonic": e.Mnemonic, "RPConsecutive": e.Consecutive, "RPDate": e.Since }) }} />
                    </div>
                </div>
            </Modal>

        </>
    )
}